export default __webpack_public_path__ + "static/dont-detach-motion-from-source-d9fb7471ff09a12e3a2c62dd3e463789eb737eed67e145c581f6e80d6877020c.png";